export const APPLICATION = "/";
export const ADMIN = "/admin";
export const ADMIN_ORGANIZATIONS = "/";
export const ADMIN_ORGANIZATION = "/organization/:organizationId?";
export const ADMIN_ADD_ORGANIZATION = "/add-organization";
export const ADMIN_USERS_INVITATIONS = "/users-invitations";
export const ADMIN_USERS = "/users";
export const ADMIN_MANAGE_ADMINS = "/manage-admins";
export const ADMIN_MANAGE_TEST_USERS = "/manage-test-users";
export const ADMIN_SUHAIL_BADGES = "/suhail-badges";
export const ADMIN_SUHAIL_COMPLAINTS = "/suhail-complaints";
export const ADMIN_SUHAIL_NOTIFICATIONS = "/suhail-notifications";
export const ADMIN_SUHAIL_OFERS = "/suhail-offers";
export const LOGIN = "/login";
export const REGISTER = "/invitation/:invitationCode";
export const ORDER = "/order/:orderCode";
export const PARCELS = "/parcels";
export const OFFERS = "/:Region/offers";
export const MAP = "/map/:id?";
export const OFFLINE_ORDERS = "/";
export const ONLINE_ORDERS = "/online-orders";
export const ONLINE_ORDER = "/online-orders/:id";
export const BATCHES = "/batches";
export const UNIT_GROUPS = "/units-group";
export const PROJECTS = "/projects";
export const CREATE_PROJECT = "/create-project";
export const PROJECT_DETAILS = "/details/:id";
export const USERS = "/users";
export const PROFILE = "/profile";
export const USER = "/user";
export const EDIT_USER = "/edit-user";
export const INTERSTED_LIST = "/intrested-list";
export const TRANSACTIONS_TRACKER = "/transactions-tracker";
export const SUBDIVISON_TRANSACTIONS = "/transactions/:viewType/:itemNo/:id";
